const REQUEST_GLOSSARY = '@@glossary/REQUEST_GLOSSARY';
const GLOSSARY_RESPONSE = '@@glossary/GLOSSARY_RESPONSE';

export default {
    REQUEST_GLOSSARY,
    GLOSSARY_RESPONSE,
};
